import { Component } from '@angular/core';
import { DialogData } from '../../services/dialog/dialog.interface';
import { DialogService } from '../../services/dialog/dialog.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  dialog: DialogData | null = null;
  inputValue: string = '';

  constructor(
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.dialogService.dialog.subscribe((dialog: any) => {
      this.dialog = dialog;
    });
  }

  closeDialog() {
    this.dialogService.clearDialog();
  }
}
